import { AnyAction } from 'redux';
import { put } from 'redux-saga/effects';
import { raiseError } from '../../../';

export function* handleRequestFail(action: AnyAction) {
  yield put(raiseError(action.data.reason));
}
